import { render } from "./Liveness.vue?vue&type=template&id=0a939804&ts=true"
import script from "./Liveness.vue?vue&type=script&lang=ts"
export * from "./Liveness.vue?vue&type=script&lang=ts"

import "./Liveness.vue?vue&type=style&index=0&id=0a939804&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__